// extracted by mini-css-extract-plugin
module.exports = {"inner":"footer-module--inner--GW_NP","nav":"footer-module--nav--8v6HN","wave":"footer-module--wave--1LLES"};